import { Getters } from 'vuex-smart-module';
import CartState from './state';

export default class CartGetters extends Getters<CartState> {
  get products_in_cart() {
    return this.state.carts_products;
  }
}
